<div class="confirm-dialog" *ngIf="showDialog">
  <div id="mobile-backdrop" class="mobile-backdrop" (click)="abortConfirmDelete()" (keypress)="onKeyPress($event)"></div>
  <div class="icons-mobile" [class.hide-modal]="showSecondConfirmDialogFlag" (touchstart)="onTouchStart($event)">
    <div class="drawer" [class.signed-in]="isSignedIn">
      <div class="handle"></div>
    </div>
    <ng-content select="isSignedIn"></ng-content>
    <ng-content select="primaryMenu"></ng-content>
  </div>
  <div class="icons-mobile" *ngIf="showSecondConfirmDialogFlag && isMobile()" (touchstart)="onTouchStart($event)">
    <div class="drawer">
      <div class="handle"></div>
    </div>
    <div class="content">
      <div class="content-header">
        <yat-icon id="6fcc04be-9598-4c5b-b74e-791be664f9c6" name="info-duo"></yat-icon>
      </div>
      <div class="content-body">
        <ng-content select="secondaryMenu"></ng-content>
      </div>
    </div>
  </div>
</div>
